import { render, staticRenderFns } from "./LegacyNoResults.vue?vue&type=template&id=43e21ad7&scoped=true&"
import script from "./LegacyNoResults.vue?vue&type=script&lang=ts&"
export * from "./LegacyNoResults.vue?vue&type=script&lang=ts&"
import style0 from "./LegacyNoResults.vue?vue&type=style&index=0&id=43e21ad7&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e21ad7",
  null
  
)

export default component.exports